// src/hooks/useTenantSettingsLive.js
import { useEffect, useEffectEvent } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ensureConnected, joinGroups, leaveGroups, onTenantSettingsChanged } from '../realtime/realtimeClient';
import { TENANT_SETTINGS_QUERY_KEY } from '../services/tenantSettings/tenantSettingsService';

export function useTenantSettingsLive() {
    const qc = useQueryClient();

    const invalidateTenantSettings = useEffectEvent(() => {
        qc.invalidateQueries({ queryKey: TENANT_SETTINGS_QUERY_KEY });
    });

    /* eslint-disable react-hooks/exhaustive-deps -- invalidateTenantSettings is useEffectEvent */
    useEffect(() => {
        let off = () => { };
        (async () => {
            await ensureConnected();
            await joinGroups(['tenant-settings']);  // group is tenant-scoped server-side
            off = onTenantSettingsChanged(() => {
                invalidateTenantSettings();
            });
        })();
        return () => { off(); leaveGroups(['tenant-settings']).catch(() => { }); };
    }, []);
    /* eslint-enable react-hooks/exhaustive-deps */
}
